import React from "react";
import { AlertTriangle, ArrowRight } from "lucide-react";

export const AlertBanner = () => (
  <div
    data-testid="alert-banner"
    className="w-full bg-[#F4E4A6] text-[#2A3430]"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-center gap-2 text-[13px] sm:text-sm font-medium text-center">
      <AlertTriangle className="h-4 w-4 shrink-0 text-[#A96444]" strokeWidth={2.25} />
      <span>
        MTD for Income Tax is mandatory from 6 April 2026 — are you ready?
      </span>
      <a
        href="#contact"
        data-testid="alert-banner-cta"
        className="hidden sm:inline-flex items-center gap-1 underline decoration-[#2A3430]/40 underline-offset-4 hover:decoration-[#2A3430] transition"
      >
        Get help now <ArrowRight className="h-3.5 w-3.5" />
      </a>
    </div>
  </div>
);

export default AlertBanner;
